import React, { useState, useEffect } from "react";
import { Dropdown, Row, Nav, Tab, Collapse } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import {
    getAllReportPlayer,
} from "../../../../services/academicService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { getCoachPlayerAttendanceReport, getPlayerSessionReport } from "../../../../services/ReportService";

const theadData = [
    { heading: "S.No", sortingVale: "sno" },
    { heading: "Player Name", sortingVale: "name" },
    { heading: "Session", sortingVale: "session" },
    { heading: "Attendance Date", sortingVale: "date" },
    { heading: "Status", sortingVale: "status" },
];

const PlayerAttendenceReports = () => {
    const [loading, setLoading] = useState(false);
    const [userData, setUserData] = useState([]);

    // pagination & search
    const [page, setPage] = useState(0); // 0-based
    const [size, setSize] = useState(10); // page size
    const [search, setSearch] = useState(""); // search text
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [currentStart, setCurrentStart] = useState(0);

    //filter
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState([]);
    const [dueList, setDueList] = useState([]);
    const [ageCategory, setAgeCategory] = useState([]);
    const [selectedDueList, setSelectedDueList] = useState(null);
    const [selectedAgeCategory, setSelectedAgeCategory] = useState(null);
    const [selectedPaymentStatus, setSelectedPaymentStatus] = useState(null);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [packageData, setPackageData] = useState(null);
    const [open, setOpen] = useState(true);

    //palyer dropdown
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [userTenant, setUserTenant] = useState(null);
    const [tenantOptions, setTenantOptions] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [pages, setPages] = useState(0); // 0-based
    const [tenantSearch, setTenantSearch] = useState("");
    const pageSize = 20;
    const [iconData, setIconDate] = useState({ complete: false, ind: Number });
    const [sessionData, setSessionData] = useState([]);
    const [selectedSession, setSelectedSession] = useState(null);

    const formatDate = (date) => {
        if (!date) return null;
        if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
            return date;
        }
        const d = new Date(date);
        if (isNaN(d.getTime())) return null;
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    // ---- API CALL WITH page, size, search ----
    async function fetchUserData({ page, size, search }) {
        setLoading(true);
        try {
            const res = await getCoachPlayerAttendanceReport(
                page,
                size,
                search,
                selectedSession,
                // selectedPlayer?.value || "",
                formatDate(startDate),
                formatDate(endDate),
            );
            setUserData(res?.content || []);
            setTotalElements(res?.totalElements || 0);
            setTotalPages(res?.totalPages || 0);
            setCurrentStart(res?.number || 0);
        } catch (error) {
            console.error("Error fetching user data:", error);
        } finally {
            setLoading(false);
        }
    }

    // initial & whenever page/size/search changes
    useEffect(() => {
        fetchUserData({
            page,
            size,
            search,
            selectedSession,
            startDate,
            endDate,
        });
    }, [page, size, search, selectedSession, startDate, endDate]);

    // ---- client sorting (optional; if you want server-side sort, pass sort to API instead) ----
    function SotingData(name) {
        const sortedPeople = [...userData];
        switch (name) {
            case "name":
                sortedPeople.sort((a, b) => {
                    const nameA = a?.player?.name || "";
                    const nameB = b?.player?.name || "";
                    return iconData.complete
                        ? nameA.localeCompare(nameB)
                        : nameB.localeCompare(nameA);
                });
                break;

            case "session":
                sortedPeople.sort((a, b) => {
                    const sA = a?.session?.name || "";
                    const sB = b?.session?.name || "";
                    return iconData.complete
                        ? sA.localeCompare(sB)
                        : sB.localeCompare(sA);
                });
                break;

            case "date":
                sortedPeople.sort((a, b) => {
                    const timeA = new Date(a?.date || 0).getTime();
                    const timeB = new Date(b?.date || 0).getTime();
                    return iconData.complete ? timeA - timeB : timeB - timeA;
                });
                break;

            case "status":
                sortedPeople.sort((a, b) => {
                    const stA = a?.status || "";
                    const stB = b?.status || "";
                    return iconData.complete
                        ? stA.localeCompare(stB)
                        : stB.localeCompare(stA);
                });
                break;

            default:
                break;
        }
        setUserData(sortedPeople);
    }

    // ---- Search handler ----
    function handleSearchChange(e) {
        const value = e.target.value;
        setSearch(value);
        setPage(0); // reset to first page on search
    }

    const downloadExcel = async () => {
        try {
            const res = await getCoachPlayerAttendanceReport(
                0,
                10000,
                search,
                selectedSession || "",
                // selectedPlayer?.value || "",
                formatDate(startDate),
                formatDate(endDate),
            );

            const formattedData = res?.content?.map((data, index) => {
                const sessionName = data?.session?.name || "-";
                const sessionTypeName = data?.session?.sessionType?.name
                    ? ` (${data.session.sessionType.name})`
                    : "";
                return {
                    "S.No": index + 1,
                    "Player Name": data?.player?.name || "-",
                    Session: `${sessionName}${sessionTypeName}`,
                    "Attendance Date": data?.date
                        ? new Date(data.date).toLocaleString()
                        : "-",
                    Status: data?.status || "-",
                };
            });

            const worksheet = XLSX.utils.json_to_sheet(formattedData || []);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Player Attendance Reports",
            );

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });

            const file = new Blob([excelBuffer], {
                type: "application/octet-stream",
            });

            saveAs(file, "player_attendance_reports.xlsx");
        } catch (error) {
            console.error("Excel download failed:", error);
        }
    };

    // const loadTenants = async (pageToLoad = 0, search = "") => {
    //     if (isLoading) return;

    //     try {
    //         setIsLoading(true);

    //         const data = await getAllReportPlayer(pageToLoad, pageSize, search);

    //         const newOptions = data.content.map((item) => ({
    //             label: item.name,
    //             value: item.id,
    //         }));

    //         if (pageToLoad === 0) {
    //             setTenantOptions(newOptions);
    //         } else {
    //             setTenantOptions((prev) => [...prev, ...newOptions]);
    //         }

    //         setPages(pageToLoad);
    //         setHasMore(!data.last);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     loadTenants();
    // }, []);

    useEffect(() => {
        fetchSession();
        // fetchPaymentStatus();
        // fetchAgeCategory();
    }, []);

    async function fetchSession() {
        try {
            const res = await getPlayerSessionReport();
            setSessionData(res);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    }

    return (
        <>
            <PageTitle
                activeMenu={"Player Attendence Reports"}
                motherMenu={"Reports"}
            />
            <div className="filter cm-content-box box-primary">
                <div className={`content-title`} onClick={() => setOpen(!open)}>
                    <div className="cpa">
                        <i className="fas fa-filter me-2"></i>Filter
                    </div>
                    <div className="tools">
                        <Link
                            to={"#"}
                            className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                        >
                            <i className="fas fa-angle-up"></i>
                        </Link>
                    </div>
                </div>
                <Collapse in={open}>
                    <div className="cm-content-body form excerpt">
                        <div className="card-body">
                            <div className="row">
                                {/* <div className="col-xl-3">
                                    <label className="form-label">Select Player</label>
                                    <Select
                                        value={selectedPlayer}
                                        options={tenantOptions}
                                        onChange={setSelectedPlayer}
                                        isClearable
                                        isLoading={isLoading}
                                        filterOption={null} // Disable frontend filtering
                                        onInputChange={(value, actionMeta) => {
                                            if (actionMeta.action === "input-change") {
                                                setTenantSearch(value);
                                                setHasMore(true);
                                                loadTenants(0, value); // Backend search
                                            }
                                        }}
                                        onMenuScrollToBottom={() => {
                                            if (hasMore && !isLoading) {
                                                loadTenants(pages + 1, tenantSearch);
                                            }
                                        }}
                                    />
                                </div> */}
                                <div className="col-xl-3">
                                    <label className="form-label">Session</label>
                                    <Select
                                        isSearchable={false}
                                        options={[
                                            { value: "", label: "All Sessions" },
                                            ...(Array.isArray(sessionData) ? sessionData : []).map(
                                                (session) => ({
                                                    value: session?.id,
                                                    label: `${session?.name}`,
                                                }),
                                            ),
                                        ]}
                                        className="custom-react-select"
                                        onChange={(e) => setSelectedSession(e.value)}
                                        placeholder="Select Session"
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Start Date</label>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={(date) => {
                                            setStartDate(date);
                                            setEndDate(null); // reset end date
                                        }}
                                        maxDate={new Date()}
                                        dateFormat="yyyy-MM-dd"
                                        className="form-control"
                                        placeholderText="Select start date"
                                    />
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">End Date</label>
                                    <DatePicker
                                        selected={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        minDate={startDate}
                                        maxDate={
                                            startDate
                                                ? new Date(
                                                    new Date(startDate).setDate(
                                                        startDate.getDate() + 90,
                                                    ),
                                                )
                                                : new Date()
                                        }
                                        disabled={!startDate}
                                        dateFormat="yyyy-MM-dd"
                                        className="form-control"
                                        placeholderText="Select end date"
                                    />
                                </div>

                                <div className="col-xl-3 d-flex align-items-end mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        style={{ height: "2.8rem" }}
                                        onClick={downloadExcel}
                                    >
                                        <i className="fas fa-file-excel me-2"></i> Download
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
            </div>
            <Row>
                <Tab.Container defaultActiveKey={"List"}>
                    <div className="col-lg-12">
                        <Tab.Content className="row tab-content">
                            {/* LIST VIEW */}
                            <Tab.Pane eventKey="List" className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="dataTables_wrapper no-footer">
                                            <div className="justify-content-between d-sm-flex mb-3">
                                                {/* PAGE SIZE DROPDOWN */}
                                                <div className="dataTables_length">
                                                    <label className="d-flex align-items-center">
                                                        Show
                                                        <Dropdown className="search-drop ms-2 me-2">
                                                            <Dropdown.Toggle
                                                                as="div"
                                                                className="search-drop-btn"
                                                            >
                                                                {size}
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {[10, 20, 30].map((val) => (
                                                                    <Dropdown.Item
                                                                        key={val}
                                                                        onClick={() => {
                                                                            setSize(val);
                                                                            setPage(0);
                                                                        }}
                                                                    >
                                                                        {val}
                                                                    </Dropdown.Item>
                                                                ))}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                        entries
                                                    </label>
                                                </div>

                                                {/* SEARCH */}
                                                <div className="dataTables_filter">
                                                    <label>
                                                        Search :{" "}
                                                        <input
                                                            type="search"
                                                            className=""
                                                            placeholder=""
                                                            value={search}
                                                            onChange={handleSearchChange}
                                                        />
                                                    </label>
                                                </div>
                                            </div>

                                            {/* TABLE WITH HORIZONTAL SCROLL */}
                                            <div className="table-responsive">
                                                <table
                                                    id="example4"
                                                    className="display dataTable no-footer w-100"
                                                >
                                                    <thead>
                                                        <tr>
                                                            {theadData.map((item, ind) => (
                                                                <th
                                                                    key={ind}
                                                                    onClick={() => {
                                                                        if (item.sortingVale === "action") return;
                                                                        SotingData(item.sortingVale);
                                                                        setIconDate((prevState) => ({
                                                                            complete: !prevState.complete,
                                                                            ind: ind,
                                                                        }));
                                                                    }}
                                                                    style={
                                                                        item.sortingVale !== "action"
                                                                            ? { cursor: "pointer" }
                                                                            : {}
                                                                    }
                                                                >
                                                                    {item.heading}
                                                                    {item.sortingVale !== "action" && (
                                                                        <span>
                                                                            {ind !== iconData.ind && (
                                                                                <i
                                                                                    className="fa fa-sort ms-2 fs-12"
                                                                                    style={{ opacity: "0.3" }}
                                                                                />
                                                                            )}
                                                                            {ind === iconData.ind &&
                                                                                (iconData.complete ? (
                                                                                    <i
                                                                                        className="fa fa-arrow-down ms-2 fs-12"
                                                                                        style={{ opacity: "0.7" }}
                                                                                    />
                                                                                ) : (
                                                                                    <i
                                                                                        className="fa fa-arrow-up ms-2 fs-12"
                                                                                        style={{ opacity: "0.7" }}
                                                                                    />
                                                                                ))}
                                                                        </span>
                                                                    )}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {!loading &&
                                                            userData?.map((data, ind) => (
                                                                <tr key={ind}>
                                                                    <td>{page * size + ind + 1}</td>
                                                                    <td>{data?.player?.name}</td>
                                                                    <td>
                                                                        {data?.session?.name}
                                                                        {data?.session?.sessionType?.name &&
                                                                            `(${data?.session?.sessionType?.name})`}
                                                                    </td>
                                                                    <td>
                                                                        {data?.date
                                                                            ? new Date(data?.date).toLocaleString()
                                                                            : ""}
                                                                    </td>
                                                                    <td>{data?.status}</td>
                                                                </tr>
                                                            ))}

                                                        {loading && (
                                                            <tr>
                                                                <td colSpan={theadData.length} className="text-center">
                                                                    Loading...
                                                                </td>
                                                            </tr>
                                                        )}

                                                        {!loading && userData?.length === 0 && (
                                                            <tr>
                                                                <td colSpan={theadData.length} className="text-center">
                                                                    No data found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* PAGINATION FOOTER */}
                                            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info">
                                                    <span>
                                                        Page{" "}
                                                        <strong>
                                                            {currentStart + 1} of {totalPages}
                                                        </strong>
                                                    </span>
                                                </div>
                                                <div className="dataTables_paginate paging_simple_numbers">
                                                    <Link
                                                        className={`paginate_button previous ${page === 0 ? "disabled" : ""
                                                            }`}
                                                        to="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (page > 0) setPage(page - 1);
                                                        }}
                                                    >
                                                        Previous
                                                    </Link>

                                                    <Link
                                                        className={`paginate_button next ${page + 1 >= totalPages ? "disabled" : ""
                                                            }`}
                                                        to="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (page + 1 < totalPages) setPage(page + 1);
                                                        }}
                                                    >
                                                        Next
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>
                        </Tab.Content>
                    </div>
                </Tab.Container>
            </Row>

        </>
    );
};

export default PlayerAttendenceReports;
